/**
 * Default options object for the root Playposit error screen.
 */
const optionsDefaults = {
  enabled: true,
  environment: (() => {
    const path = window.location.pathname.replace(new RegExp('/', 'g'), ' ').trim();
    if (!path.length) return 'default';
    return path.replace(' ', '-');
  })(),
  vertical: false,
  active_color: '#2196F3',
  base_color: '#1976D2',
  inactive_color: '#FFFFFF',
  title: 'Error',
  subtitle: '',
  center_subtitle: false,
  text: 'Something went wrong.',
  code: 500,
  icon: 'error',
  buttons: [
    {
      text: 'Refresh',
      order: 0,
      action: 'refresh',
    },
  ],
  logoURL: 'https://bunny.playposit.com/images/logo_white.png',
  enableLogo: true,
};

// Logic that determines if the 'back' button should be added to the error screen:
if (window.history.length) {
  optionsDefaults.buttons.push({
    text: 'Back',
    type: 'outline',
    action: 'return',
  });
}

// Generate the option_fields object from the default options object above:
const option_fields = Object.keys(optionsDefaults); // eslint-disable-line

// Export the default options and the options fields:
export default {
  optionsDefaults,
  option_fields,
};